// Edge node connectivity status — shared by SettingsPage.tsx (management
// grid), ScadaView.tsx (operator status bar) and ExecutiveDashboard.tsx
// (dashboard panel), so all three read the same severity-tone shape
// (Good/Active Blue "ok", warning, critical, Concrete Gray "unknown") off
// one source instead of drifting. Thresholds keyed off the edge config's
// own 60s sync_interval default — a few missed cycles before flagging, to
// avoid false positives from one slow check-in.

export type EdgeConnStatus = 'ok' | 'warning' | 'critical' | 'unknown' | 'disabled'

export interface EdgeNodeStatusInput {
  active: boolean
  last_seen_at: string | null
}

export function edgeConnStatus(node: EdgeNodeStatusInput): EdgeConnStatus {
  if (!node.active) return 'disabled'
  if (!node.last_seen_at) return 'unknown'
  const minutesAgo = (Date.now() - new Date(node.last_seen_at).getTime()) / 60_000
  if (minutesAgo <= 3) return 'ok'
  if (minutesAgo <= 10) return 'warning'
  return 'critical'
}

export const EDGE_STATUS_LABEL: Record<EdgeConnStatus, string> = {
  ok:       'Aktivan',
  warning:  'Kasni',
  critical: 'Van mreže',
  unknown:  'Nikad povezan',
  disabled: 'Deaktiviran',
}
export const EDGE_STATUS_DOT: Record<EdgeConnStatus, string> = {
  ok:       'bg-brand-cyan',
  warning:  'bg-brand-warning',
  critical: 'bg-brand-critical',
  unknown:  'bg-brand-gray',
  disabled: 'bg-gray-300',
}
export const EDGE_STATUS_TEXT: Record<EdgeConnStatus, string> = {
  ok:       'text-brand-cyan-text',
  warning:  'text-brand-warning-text',
  critical: 'text-brand-critical-text',
  unknown:  'text-brand-gray-text',
  disabled: 'text-gray-500',
}
// bg/border pill combo — same five states, for badge-shaped (not just
// dot+label) presentations like ScadaView's status bar.
export const EDGE_STATUS_PILL: Record<EdgeConnStatus, string> = {
  ok:       'bg-blue-50 text-brand-cyan-text border-blue-200',
  warning:  'bg-orange-50 text-brand-warning-text border-orange-200',
  critical: 'bg-red-50 text-brand-critical-text border-red-200',
  unknown:  'bg-gray-50 text-brand-gray-text border-gray-200',
  disabled: 'bg-gray-100 text-gray-500 border-gray-200',
}
